const SvgCloud3 = (props) => (
  <>
    <circle cx={128.06} cy={384.24} r={4} fill={props.p50} />
    <path
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
      d="M181.31 95.77V31.74L128.15-.28 75 31.74v64.03l53.15 32.02 53.16-32.02zM181.31 224.16v-63.97l-53.16-31.98L75 160.19v63.97l53.15 31.98 53.16-31.98zM181.31 352.53v-63.87l-53.16-31.94L75 288.66v63.87l53.15 31.94 53.16-31.94z"
    />
    <circle cx={128.15} cy={256.37} r={4} fill={props.p50} />
    <circle cx={128.06} cy={128.4} r={4} fill={props.p50} />
    <circle cx={128.15} cy={0.52} r={4} fill={props.p50} />
  </>
);

export default SvgCloud3;
